import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IEMRLayout } from '@care-portals/api-interfaces';
import { APP_FEATURE_KEY, State, AppPartialState } from './app.reducer';

export const getAppState = createFeatureSelector<AppPartialState, State>(
  APP_FEATURE_KEY
);

export const getAppLoading = createSelector(
  getAppState,
  (state: State) => state.loading
);

export const getAppError = createSelector(
  getAppState,
  (state: State) => state.error
);

export const getAllLayouts = createSelector(
  getAppState,
  (state: State) => state.layouts
);

export const getSelectedLayout = createSelector(getAppState, (state: State) => {
  if (state.layouts !== null && state.selectedLayoutIndex !== null)
    return state.layouts[state.selectedLayoutIndex] as IEMRLayout;

  return null;
});
